// PhotoSection.js
import React, { useRef, useEffect, useState } from 'react';
import { motion } from "framer-motion";
import './PhotoSection.css';

// PhotoSection.js

const PhotoSection = () => {
  const images = [
    { src: "/external/images/Atl images/img1.jpeg" },
    { src: "/external/images/Atl images/img2.jpeg" },
    { src: "/external/images/Atl images/img3.jpeg" },
    { src: "/external/images/Atl images/img4.jpeg" },
    { src: "/external/images/Atl images/img5.jpeg" },
    { src: "/external/images/Atl images/img6.jpeg" },
  ];

  const [width, setWidth] = useState(0);
  const carousel = useRef();

  useEffect(() =>{
    setWidth(carousel.current.scrollWidth - carousel.current.offsetWidth);
  }, []);


  return (
    <div className="carousel-container">
      <motion.div ref={carousel} className='carousel'>
        <motion.div drag="x" dragConstraints = {{right: 0, left: -width }} className='inner-carousel'>
          {images.map((image) =>{
            return(
              <motion.div className='item' key={image.src}>
                <img src= {image.src}  alt=" "/>
              </motion.div>
            );
          })}
        </motion.div> 

      </motion.div>
    </div>
  );
};


export default PhotoSection;
